'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class reductionModel extends ngDepModel
{

	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}


	getValue(name){
		switch(name){
			case 'status':
				return this.getClassifValue(name, 'reduction_status');
			case 'apply_reduction_to_participants':
				return this.getClassifValue(name, 'yesno');
			case 'amount':
			case 'paid_amount':
			case 'late_interest_amount':
				return this.s('$filter')('currency')(this[name]);
			case 'date':
			case 'created':
				if(this[name] == 0){
					return '';
				}
				return this.s('$filter')('u2date')(this[name]);
			case 'comment':
				return this.s('$filter')('nl2br')(this[name]);

		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		return null;
	}


	afterSetup(data){
		if (typeof this.amount !== 'undefined' && !isNaN(this.amount) && this.amount > 0) {
			this.amount = Number(parseFloat(this.amount).toFixed(2));
		} else {
			this.amount = Number(0.00);
		}
		if(this.date > 0){
			this.makeCetField('date', true);
			this.date_cet.setHours(12);
		}
		else{
			this.date_cet = null;
		}
	}

	setFloatNumber(value){
		let precision = 2;
		if(arguments[1]){
			precision = parseInt(arguments[1]);
		}
		if(!isNaN(value)){
			return Number(parseFloat(value).toFixed(precision));
		}
		else{
			return Number(0.0);
		}
	}
}
